import {Panel, PanelCol, PanelContainer, Triangle} from '../components/Panel';
import Picture from '../assets/images/picture-02.svg';
import PictureTriangle from '../assets/images/triangle.svg';
import Header from '../components/Header';
import {t} from 'i18next';

const pageNotFound = () => {
  return (
    <>
      <Header />
      <PanelContainer>
        <Panel>
          <PanelCol>
            <Triangle src={PictureTriangle} alt="" />
            <img src={Picture} alt="" />
          </PanelCol>
          <PanelCol>
            <h1>{t('errors.404')}</h1>
            <p>{t('errors.404-subtitle')}</p>
          </PanelCol>
        </Panel>
      </PanelContainer>
    </>
  );
};

export default pageNotFound;
